import { useState, useEffect } from 'react';

function useUpdatingObservable(value, observable, deps) {
  const [snapshot, setSnapshot] = useState(value);
  useEffect(() => {
    setSnapshot(value);
    const subscription = observable == null ? void 0 : observable.subscribe({
      next: (updatedValue) => {
        setSnapshot(updatedValue);
      },
      complete: () => {
        subscription == null ? void 0 : subscription.unsubscribe();
      }
    });
    return () => {
      subscription == null ? void 0 : subscription.unsubscribe();
    };
  }, deps);
  return snapshot;
}

export { useUpdatingObservable };
//# sourceMappingURL=useUpdatingObservable.esm.js.map
